export default __webpack_public_path__ + "static/media/kava.3c4a7d27.svg";